import { Subject } from "rxjs";
import { log2 } from "./log2";

const messages = new Subject();
const log = log2("PUB_SUB");
export const SystemMessageTypes = {
    TAB_VISIBILITY_CHANGE: "tab_visibility_change",
    OPEN_CHAT: "open_chat",
    INVOICE_CREATED: "invoice-created",
    CONNECT_SUPPORT_TEAM: "connect-support-team",
    SW_REGISTERED: "sw-registered",
    NOTIFICATION_GRANTED: "notification-granted",
};
export const publishMessage = (type, payload) => {
    log("publishMessage", { type, payload });
    messages.next({
        type,
        payload,
    });
};

export const systemMessageStream = messages.asObservable();

document.addEventListener("visibilitychange", () => {
    publishMessage(SystemMessageTypes.TAB_VISIBILITY_CHANGE, {
        visible: document.visibilityState === "visible",
    });
});

const SYSTEM_PUBSUB = {
    stream: systemMessageStream,
    publish: publishMessage,
    MESSAGE_TYPES: SystemMessageTypes,
};
export default SYSTEM_PUBSUB;
